export default __webpack_public_path__ + "static/media/Graphik-BlackItalic.541296f4.otf";